import React from 'react';
import {usePaymentSettings} from "../hooks";
import Setting from "./setting";


export default function Settings() {
    const {data, isLoading} = usePaymentSettings()

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="p-5">
            <h4>Payment Settings</h4>
            <div className="mt-3" style={{"marginBottom": "200px"}}>
                {data?.results?.filter(setting => {
                    // hide REQUIRE_REGISTERED_ACTIVE_LOT setting
                    return setting.key !== 'REQUIRE_REGISTERED_ACTIVE_LOT';
                }).map((setting) => (
                    <Setting key={setting.key} data={setting} />
                ))}
            </div>
        </div>
    )
}